import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

Vue.use(Vuex)

const vuexLocalStorage = new VuexPersist({
  storage: window.localStorage
})

export default new Vuex.Store({
  state: {
    isHelpDismissed: false,
    isNewsletterDismissed: false,
    navigationTime: 0
  },
  getters: {
    isHelpDismissed: state => state.isHelpDismissed,
    isNewsletterDismissed: state => state.isNewsletterDismissed,
    navigationTime: state => state.navigationTime
  },
  actions: {
    dismissHelp: ({ commit }) => {
      commit('dismissHelp')
    },
    dismissNewsletter: ({ commit }) => {
      commit('dismissNewsletter')
    },
    incrementTime: ({ commit }) => {
      commit('incrementTime')
    }
  },
  mutations: {
    dismissHelp: state => {
      state.isHelpDismissed = true
    },
    dismissNewsletter: state => {
      state.isNewsletterDismissed = true
    },
    incrementTime: state => {
      state.navigationTime++
    }
  },
  plugins: [vuexLocalStorage.plugin]
})
